import { GlobalApplicationContext } from "@fastoche/ui-core/application/GlobalApplicationContext";
import { TrackingEventDispatcher } from "../module/TrackingEventDispatcher";
export function TrackingPlugin({ logger }) {
    return {
        install: (_Vue) => {
            let dispatcher;
            _Vue.prototype.$track = async function (eventName, eventPayload) {
                dispatcher ??= GlobalApplicationContext.default.fastoche.rootContainer.get(TrackingEventDispatcher);
                try {
                    await dispatcher.dispatchByName(eventName, eventPayload);
                }
                catch (e) {
                    logger.warn("Error happened while tracking event from component", {
                        event: eventName,
                        payload: eventPayload,
                        error: e,
                    });
                }
            };
        },
    };
}
//# sourceMappingURL=index.js.map